import { render, staticRenderFns } from "./GChatVideoMessage.vue?vue&type=template&id=258b351e&"
import script from "./GChatVideoMessage.vue?vue&type=script&lang=ts&"
export * from "./GChatVideoMessage.vue?vue&type=script&lang=ts&"
import style0 from "./GChatVideoMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports